var map = {
	"./bnb.svg": "a555",
	"./btc.svg": "cdc9",
	"./eth.svg": "4c03",
	"./trx.svg": "8162",
	"./usdc.svg": "f803",
	"./usdt.svg": "ebb1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0313";